import { render, staticRenderFns } from "./MailEditor.vue?vue&type=template&id=40198484&"
import script from "./MailEditor.vue?vue&type=script&lang=js&"
export * from "./MailEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailEditor.vue?vue&type=style&index=0&id=40198484&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40198484')) {
      api.createRecord('40198484', component.options)
    } else {
      api.reload('40198484', component.options)
    }
    module.hot.accept("./MailEditor.vue?vue&type=template&id=40198484&", function () {
      api.rerender('40198484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MailEditor.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/MailEditor.vue
// module id = 501
// module chunks = 9